// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Category-AssignToItemModal-Items-__style___3GUvc","row-wrapper":"app-pages-Library-Category-AssignToItemModal-Items-__style___1Xj5z","item-image-wrapper":"app-pages-Library-Category-AssignToItemModal-Items-__style___2eJu5","item-name-wrapper":"app-pages-Library-Category-AssignToItemModal-Items-__style___1mKq6","image":"app-pages-Library-Category-AssignToItemModal-Items-__style___1aqJS","padding-checkbox":"app-pages-Library-Category-AssignToItemModal-Items-__style___1qbPR"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Category/AssignToItemModal/Items/style.css
// module id = 2149
// module chunks = 0